import axios from 'axios';

export const search = async (query: string, token: string) =>
  axios.get(`${process.env.REACT_APP_CHEVROLET_URL}/search?query=${query}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
